export default "__VITE_PUBLIC_ASSET__9e67802b__"